<template>
  <b-field class="mb-0">
    <b-input :id="id" :value="value" @input="(value) => $emit('input', value)" @blur="$emit('save', value)"></b-input>
    <p class="control" v-if="addon">
      <span class="button is-static">{{ addon }}</span>
    </p>
  </b-field>
</template>
<script>
export default {
  props: {
    id: String,
    value: String,
    addon: String
  }
}
</script>